"use client";

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQProps {
  faqs: FAQItem[];
  type?: "single" | "multiple";
  className?: string;
}
const FAQ = t0 => {
  const $ = _c(9);
  const {
    faqs,
    type: t1,
    className
  } = t0;
  const type = t1 === undefined ? "multiple" : t1;
  if (!faqs || faqs.length === 0) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="font-medium font-outfit lg:text-[24px] text-[#3E3D4D] text-2xl mb-6">Frequently Asked Questions</h2>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== faqs) {
    t3 = faqs.map(_temp);
    $[1] = faqs;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3 || $[4] !== type) {
    t4 = <Accordion type={type}>{t3}</Accordion>;
    $[3] = t3;
    $[4] = type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className || $[7] !== t4) {
    t5 = <section className={className}>{t2}{t4}</section>;
    $[6] = className;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default FAQ;
function _temp(faq, index) {
  return <AccordionItem key={index} value={`item-${index}`}><AccordionTrigger className="text-left w-full">{faq.question}</AccordionTrigger><AccordionContent>{faq.answer}</AccordionContent></AccordionItem>;
}